import React from 'react';
import Modal from 'components/Modal';

type Props = {
  error?: any,
  isOpen: boolean,
  onRequestClose: () => void,
};

export default function PurchaseSubscriptionErrorModal({
  error,
  isOpen,
  onRequestClose,
}: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <h3 className="heading heading--2 heading--inverse">Subscription failed</h3>
      <hr style={{ marginTop: '.25rem' }} />
      {error?.message && (
        <p>
          {error.message}
        </p>
      )}
    </Modal>
  );
}